import {utilityServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = utilityServicesPath + '/user/files/upload/cv-files'

export default class UserFileUploadController {
    static getFormData(selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        return formData;
    }

    static async add(data, selectedFiles) {
        return await axios.post(`${restUrl}?FCs=${data.FCs}&contact=${data.contact}&comment=${data.comment}`, UserFileUploadController.getFormData(selectedFiles));
    }
}